import { render, staticRenderFns } from "./IBOStudentForm.vue?vue&type=template&id=4b2fcc4c&scoped=true&"
import script from "./IBOStudentForm.vue?vue&type=script&lang=js&"
export * from "./IBOStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./IBOStudentForm.vue?vue&type=style&index=0&id=4b2fcc4c&prod&scoped=true&lang=scss&"
import style1 from "./IBOStudentForm.vue?vue&type=style&index=1&id=4b2fcc4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fcc4c",
  null
  
)

export default component.exports